import React from 'react';
import './pdp-addons.scss';
import Icon from '../../mweb/Icon/Icon';

const HorizontalAddon = ({ addon, desktop = false }) => {
  return (
    <div className="horizontal-addon">
      <div className="horizontal-addon--header flex-align-items-center">
        {addon.imageURL && (
          <Icon
            src={addon.imageURL}
            size={desktop ? 44 : 52}
            class="horizontal-addon--header--icon"
          />
        )}
        {addon.name && (
          <div className="horizontal-addon--header--title">{addon.name}</div>
        )}
      </div>
      <div className="horizontal-addon--addons">
        {addon?.details?.map((a, index) => {
          return (
            <Icon
              src={a.imageURL}
              height={desktop ? 192 : 152}
              width={desktop ? 176 : 140}
              class="horizontal-addon--addons--addon"
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HorizontalAddon;
